<template>
    <div class="search-page">
        <HeaderPc />
        <div class="container">
            <div class="search-main">
                <div class="search-box-wrap">
                    <div class="search-form">
                        <el-select v-model="searchType" class="search-type-select">
                            <el-option label="课程名称" value="courseName"></el-option>
                            <el-option label="讲师名称" value="teacher"></el-option>
                        </el-select>
                        <el-input 
                            v-model="searchKeyword" 
                            placeholder="请输入搜索关键词" 
                            class="search-input"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                        <el-button type="primary" class="search-btn" @click="handleSearch">搜索</el-button>
                    </div>
                    <div class="search-tips">
                        <span>搜索提示：支持课程名称、讲师名称搜索</span>
                        <el-button type="text" @click="clearSearch" v-if="hasSearched">清空搜索</el-button>
                    </div>
                </div>

                <div v-if="hasSearched">
                    <div class="result-stats" v-if="courseList.length > 0">
                        <h3>找到 <span>{{ total }}</span> 个相关课程</h3>
                    </div>

                    <div class="course-result-list" v-if="courseList.length > 0">
                        <div 
                            class="course-card" 
                            v-for="course in courseList" 
                            :key="course.id"
                            @click="goCourseDetail(course.id)"
                        >
                            <div class="course-cover">
                                <img :src="getImageUrl(course.cover)" :alt="course.name" @error="handleCoverError">
                                <span class="video-tag">{{ course.ctype == 1 ? '视频' : '课件' }}</span>
                            </div>
                            <div class="course-info">
                                <h4 class="course-title" v-html="highlightKeyword(course.name)"></h4>
                                <div class="course-meta">
                                    <span class="teacher"><i class="el-icon-user"></i> <span v-html="highlightKeyword(course.author_name || '')"></span></span>
                                    <span v-if="course.view_count"><i class="el-icon-view"></i> {{ course.view_count || 0 }}次播放</span>
                                </div>
                                <p class="course-desc" v-if="course.desc">{{ course.desc }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="pagination-wrap" v-if="courseList.length > 0">
                        <el-pagination
                            background
                            layout="total, prev, pager, next, jumper"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            :total="total"
                            @current-change="handlePageChange"
                        >
                        </el-pagination>
                    </div>

                    <div class="empty-state" v-else>
                        <i class="el-icon-search"></i>
                        <p>未找到相关课程</p>
                        <el-button type="primary" @click="clearSearch">重新搜索</el-button>
                    </div>
                </div>

                <div class="empty-state" v-else>
                    <i class="el-icon-search"></i>
                    <p>请输入关键词开始搜索</p>
                </div>
            </div>
        </div>
        <FooterPc />
    </div>
</template>

<script>
import HeaderPc from '@/components/pc/header.vue'
import FooterPc from '@/components/pc/fotter.vue'
import { getByName } from '@/api/home'

export default {
    name: 'SearchPage',
    components: {
        HeaderPc,
        FooterPc
    },
    data() {
        return {
            searchType: 'courseName',
            searchKeyword: '',
            hasSearched: false,
            courseList: [],
            currentPage: 1,
            pageSize: 12,
            total: 0
        }
    },
    created() {
        this.loadFromQuery()
    },
    watch: {
        '$route.query': {
            handler() {
                this.loadFromQuery()
            },
            deep: true
        }
    },
    methods: {
        loadFromQuery() {
            const keyword = this.$route.query.keyword
            const type = this.$route.query.type
            if (keyword) {
                this.searchKeyword = keyword
                if (type) this.searchType = type
                this.fetchData()
            }
        },
        handleSearch() {
            if (!this.searchKeyword.trim()) return this.$message.warning('请输入搜索关键词')
            this.currentPage = 1
            this.fetchData()
        },
        fetchData() {
            this.hasSearched = true
            
            const params = {
                keyword: this.searchKeyword.trim(),
                type: this.searchType === 'courseName' ? 1 : 2,
                page: this.currentPage,
                limit: this.pageSize
            }
            
            getByName(params).then(res => {
                this.courseList = res.data.list || []
                this.total = res.data.total || 0
            }).catch(error => {
                this.$message.error('搜索失败，请稍后重试')
                this.courseList = []
                this.total = 0
            })
        },
        clearSearch() {
            this.searchKeyword = ''
            this.searchType = 'courseName'
            this.hasSearched = false
            this.courseList = []
            this.currentPage = 1
            this.total = 0
        },
        handleCoverError(e) {
            e.target.src = require('@/static/imgs/default.jpeg')
        },
        goCourseDetail(id) {
            this.$router.push(`/course/${id}`)
        },
        highlightKeyword(text) {
            if (!text || !this.searchKeyword) return text
            const reg = new RegExp(this.searchKeyword, 'gi')
            return text.replace(reg, match => `<span class="keyword-highlight">${match}</span>`)
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg')
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url
            return process.env.VUE_APP_STATIC_URL + url
        },
        handlePageChange(page) {
            this.currentPage = page
            this.fetchData()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
}
</script>

<style scoped>
.search-page {
    min-height: 100vh;
    background: #f5f5f5;
}
.container {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0 40px;
}

.search-main {
    min-height: 500px;
}
.search-box-wrap {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
}
.search-form {
    display: flex;
    align-items: center;
    gap: 12px;
}
.search-type-select {
    width: 120px;
}
.search-input {
    flex: 1;
}
.search-btn {
    width: 100px;
}
.search-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
    font-size: 12px;
    color: #666;
}

.result-stats {
    background: #fff;
    padding: 16px 24px;
    border-radius: 12px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.result-stats h3 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
}
.result-stats h3 span {
    color: #2d8cf0;
}

.course-result-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
}
.course-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    transition: all 0.3s ease;
}
.course-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(24, 144, 255, 0.15);
}
.course-cover {
    position: relative;
    width: 100%;
    height: 160px;
    overflow: hidden;
}
.course-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}
.course-card:hover .course-cover img {
    transform: scale(1.05);
}
.video-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 2px 8px;
    background: rgba(24, 144, 255, 0.9);
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
}
.course-info {
    padding: 16px;
}
.course-title {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    margin: 0 0 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.keyword-highlight {
    color: #f56c6c;
    font-weight: 600;
}
.course-meta {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    font-size: 12px;
    color: #666;
}
.course-meta span {
    display: flex;
    align-items: center;
}
.course-meta i {
    font-size: 10px;
    margin-right: 4px;
}
.course-desc {
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.empty-state {
    background: #fff;
    border-radius: 12px;
    text-align: center;
    padding: 80px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.empty-state i {
    font-size: 64px;
    color: #cbd5e1;
    margin-bottom: 16px;
}
.empty-state p {
    font-size: 16px;
    color: #94a3b8;
    margin-bottom: 24px;
}

.pagination-wrap {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

@media (max-width: 1280px) {
    .course-result-list {
        grid-template-columns: repeat(3, 1fr);
    }
}
@media (max-width: 960px) {
    .course-result-list {
        grid-template-columns: repeat(2, 1fr);
    }
}
@media (max-width: 576px) {
    .course-result-list {
        grid-template-columns: 1fr;
    }
    .search-form {
        flex-wrap: wrap;
    }
    .search-type-select,
    .search-input,
    .search-btn {
        width: 100%;
    }
}
</style>
